import {
    Chip,
    IconButton,
    Stack,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Tooltip,
    Typography,
} from "@mui/material";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import { CounterpartyChannel } from "../counterpartyApi";


export const CounterpartyChannelsTab = ({
    channels,
    onEdit,
}: {
    channels: CounterpartyChannel[];
    onEdit: (channelId: number) => void;
}) => {
    if (!channels || channels.length === 0) {
        return <Typography variant="body2" color="text.secondary">Brak kanałów</Typography>;
    }

    return (
        <Table size="small">
            <TableHead>
                <TableRow>
                    <TableCell>Typ</TableCell>
                    <TableCell>Wartość</TableCell>
                    <TableCell>Flagi</TableCell>
                    <TableCell align="right">Akcje</TableCell>
                </TableRow>
            </TableHead>

            <TableBody>
                {channels.map((c) => (
                    <TableRow key={c.id} hover>
                        <TableCell>{c.channelType ?? "—"}</TableCell>
                        <TableCell>{c.value ?? "—"}</TableCell>
                        <TableCell>
                            {c.isPrimary ? <Chip size="small" label="Primary" /> : "—"}
                        </TableCell>
                        <TableCell align="right">
                            <Tooltip title="Edytuj">
                                <IconButton size="small" onClick={() => onEdit(c.id)}>
                                    <EditOutlinedIcon fontSize="small" />
                                </IconButton>
                            </Tooltip>
                        </TableCell>
                    </TableRow>
                ))}
            </TableBody>
        </Table>
    );
};